// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"28":"certificate","177":"home","535":"login"}[chunkId] || chunkId) + ".20230410163030.js";
};